"use client";

import Link from "next/link";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useTheme } from "next-themes";
import "./not-found.css";

export default function NotFound() {
    const { resolvedTheme } = useTheme();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const isDark = mounted && resolvedTheme === "dark";
    const iconSrc = isDark ? "/errors/404_darkmode.svg" : "/errors/404.svg";

    return (
        <div
            className="not-found-root"
            style={{
                width: "100%",
                height: "100vh",
                minHeight: 800,
                position: "relative",
                overflow: "hidden",
                fontFamily:
                    '"DM Sans", system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
            }}
        >
            {/* ICON GROUP (circle + icons) */}
            <div
                style={{
                    position: "absolute",
                    top: 171,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 156,
                    height: 156,
                }}
                aria-hidden="true"
            >
                {/* White Circle */}
                <svg
                    viewBox="0 0 171 171"
                    width="100%"
                    height="100%"
                    style={{ display: "block" }}
                >
                    <defs>
                        <filter
                            id="circleShadow404"
                            x="0"
                            y="0"
                            width="170.2"
                            height="170.2"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            />
                            <feOffset dx="5" dy="5" />
                            <feGaussianBlur stdDeviation="3.55" />
                            <feComposite operator="out" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend mode="normal" in2="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" />
                        </filter>
                    </defs>
                    <g filter="url(#circleShadow404)">
                        <circle
                            cx="80.1"
                            cy="80.1"
                            r="78"
                            fill="var(--not-found-circle, #ffffff)"
                        />
                    </g>
                </svg>

                {/* 404 Icon */}
                <div
                    style={{
                        position: "absolute",
                        top: 32,
                        left: 36,
                        width: 84,
                        height: 84,
                    }}
                >
                    <Image
                        src={iconSrc}
                        alt=""
                        aria-hidden="true"
                        width={84}
                        height={84}
                        style={{ display: "block" }}
                    />
                </div>
            </div>

            {/* TEXT */}
            <div
                className="not-found-title"
                style={{
                    position: "absolute",
                    top: 365,
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontSize: 34,
                    fontWeight: 600,
                    lineHeight: "48px",
                    textAlign: "center",
                }}
            >
                ERROR 404
            </div>

            <div
                className="not-found-text"
                style={{
                    position: "absolute",
                    top: 443,
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontSize: 24,
                    fontWeight: 400,
                    lineHeight: "33px",
                    textAlign: "center",
                    width: 551,
                    maxWidth: "90%",
                }}
            >
                Page Not Found
            </div>

            <div
                className="not-found-text"
                style={{
                    position: "absolute",
                    top: 501,
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontSize: 24,
                    fontWeight: 400,
                    lineHeight: "33px",
                    textAlign: "center",
                    width: 541,
                    maxWidth: "90%",
                }}
            >
                The page you&apos;re looking for doesn&apos;t exist or has been
                moved.
            </div>

            {/* BUTTON */}
            <Link
                href="/"
                style={{
                    position: "absolute",
                    top: 626,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 257,
                    height: 47,
                    borderRadius: 8,
                    backgroundColor: "var(--not-found-accent, #9334e9)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textDecoration: "none",
                    fontWeight: 700,
                    fontSize: 20,
                    color: "var(--not-found-button-text, #fff)",
                }}
            >
                Back to Home
            </Link>

            {/* GO BACK */}
            <button
                type="button"
                onClick={() => window.history.back()}
                className="not-found-link"
                style={{
                    position: "absolute",
                    top: 718,
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontWeight: 700,
                    fontSize: 20,
                    textDecoration: "none",
                }}
            >
                Go Back
            </button>
        </div>
    );
}
